import { render, staticRenderFns } from "./CoverPicker.vue?vue&type=template&id=5866a5f4&scoped=true&"
import script from "./CoverPicker.vue?vue&type=script&lang=js&"
export * from "./CoverPicker.vue?vue&type=script&lang=js&"
import style0 from "./CoverPicker.vue?vue&type=style&index=0&id=5866a5f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5866a5f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VParallax } from 'vuetify/lib/components/VParallax';
installComponents(component, {VBtn,VFlex,VLayout,VParallax})
